export const SHOP_BASE_URL = "https://shop.waterdoctor.ca";
export const SHOP_HOSTNAME = "shop.waterdoctor.ca";
export const SHOP_HANDOFF_DIRECTION = "official_to_shop";

const CAMPAIGN_PARAM_NAMES = [
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_id",
  "utm_term",
  "utm_content",
];

function getHandoffPlacement(overrides = {}) {
  return (
    overrides.wd_placement ||
    overrides.utm_content ||
    overrides.utm_campaign ||
    overrides.utm_term
  );
}

/**
 * Build an official-site to Shopify handoff URL without creating a new
 * marketing campaign. Runtime identity parameters are added by
 * ShopOutboundAttribution in the browser.
 */
export function getTrackedShopUrl(pathOrUrl = "/", overrides = {}) {
  const url = pathOrUrl.startsWith("http")
    ? new URL(pathOrUrl)
    : new URL(pathOrUrl, SHOP_BASE_URL);

  CAMPAIGN_PARAM_NAMES.forEach((key) => url.searchParams.delete(key));

  url.searchParams.set("wd_handoff", SHOP_HANDOFF_DIRECTION);
  const placement = getHandoffPlacement(overrides);
  if (placement) url.searchParams.set("wd_placement", placement);

  Object.entries(overrides).forEach(([key, value]) => {
    if (!value || key.startsWith("utm_") || key === "wd_placement") return;
    url.searchParams.set(key, value);
  });

  return url.toString();
}

/**
 * Build a shop chat deep link that triggers Shopify Inbox auto-open on shop pages.
 */
export function getShopInboxChatUrl(source = "official") {
  const url = new URL(
    getTrackedShopUrl("/", {
      wd_placement: `chat_${source}`,
    }),
  );
  url.searchParams.set("open_chat", "1");
  url.searchParams.set("chat_source", source);
  return url.toString();
}
